/* eslint-disable camelcase */
import React, { useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Header from './header';
import Footer from './footer/ReportUsageFooter';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import RecordViewContainer from './record/view';
import ProcedureViewContainer from './procedure/view';
import ReplenViewContainer from './replen/view';
import useReportUsageScreenRenders from './hooks/useReportUsageScreenRenders';
import {
    REPORTPROGRESSTEP,
    REPORTPROGRESSTEPSWITHOUTPROCEDURE,
    REPORTPROGRESSTEPSWITHOUTREPLEN,
    REPORTPROGRESSTEPSWITHOUTREPLENANDPROCEDURE,
    REPORTUSAGEBUTTON,
    REPORTUSAGEVALIDATEACCOUNT,
} from 'src/constants/productConstants';
import { initialButtonState } from './footer/InitialButtonState';
import SubmitViewContainer from './submit/view';
import UnidSurgeryInfo from './procedure/components/unidSurgery/UnidSurgeryInfo';
import StepUpProgressBar from 'src/pages/reportUsage/common/StepUpProgressBar';
import ReportUsageSubHeader from 'src/pages/reportUsage/header/ReportUsageSubHeader';
import ReviewContainer from 'src/pages/reportUsage/review/view';
import procedureBtnClickHandlerUtil from './handlers/procedureBtnClickHandlerUtil';
import reviewBtnClickHandlerUtil from './handlers/reviewBtnClickHandlerUtil';
import {
    setPatientDetails, storeItemTableData, setLocalSignature, fetchUsageDetailsRequest, getProcedureInfoRequest, 
    getDropdownOptionsRequest, createUsageOrderRequest, updateUsageOrderRequest, setProgressBarStatus, setProgressBarCurrentStep, 
    resetProgressBarStatus, resetReportUsageStates, validateProductDetails, validateUnidPlanFeeItems, validateMazorCodeRequest, 
    setPriceOverrideDetails, setPriceOverridePage, setShowUnsavedReportUsageChangesPopUp, storeUsageDataPresist, putDisparencyData, setProcedureData, setPhysicianProcedureDropdownValue, 
    setPhysicianTextData, setShippingDetails, setDiscrepancyEmailIds, setSubmitClicked, setDiscrepancyUsageValueExist,
    setReportUsageFormObject, setReportPaymentScreenName, setIsErrorExist, editUsageDetails, 
    setSelectedOutsideAccount, setRetractorUsedOtherField, setUivDropdownValue, setLivDropdownValue, 
    addProcedureLevel, resetLevelData, setMazorCaseCoverageValue, resetMazxorCaseCoverage,
    setProcedureValue, setStealthCaseCoverageValue, resetStealthCaseCoverage,
    setIsConfirmationChecked,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { SET_ADVANCE_ENERGY_DATA } from 'src/pages/reportUsage/redux/action/types';
import { removePricingDetailsUtil } from './utils/removePricingDetails';
import {
    getValidateItemsArr, getValidatedItemTableData, getValidReplenishGridData, getUpdatedPriceOverridenData, modifyDraftProductsResponse,
    getRPValidateItemsArr, getRPValidatedItemTableData, getProductsArrFromReportPaymentFlow, getReplenNonTissueItems, setShippingDetailsRP,
    getPriceInNumberDataType, deletePricingDetails, modifyDraftProcedureDataResponse, isValidLotSerial,
} from './utils/dataModificaionUtil';
import {
    getModifiedButtonVisibilities, checkIfValidPricedItems, isPriceOverrideApplyBtnDisabled, checkIfValidProductsInRecordScreen, createRecordAndReplenDraftOrderObj,
    checkIfValidReportPaymentData, getPatientDetailsInDraftOrder, createReportPaymentSubmissionProductsArr, getProgressBarStateOnLoad, toggleSaveExitButton,
    getTotalQuantity, checkIfValidData, createProcedureDraftOrderObject,
} from './utils/eventHandlerUtil';
import {
    getRoutePathWithParams, isMobileView, navLinkSelectHandler, hideScrolling, resumeScrolling, 
    getOrderLockedAction, removePersistKey, generate_UUID, setCurrencyFormat,
    checkProxyActive, checkImpersonationActive, debounce, logErrorToConsole,
    setMyCaseRef,
} from 'src/utils/util';
import SurgeryOrReport from './procedure/components/unidSurgery/SurgeryOrReport';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ReportPaymentIcon from 'src/assets/images/ReportPaymentIcon.svg';
import ReportPaymentDisabledIcon from 'src/assets/images/ReportPaymentDisabled.svg';
import {
    setOrderStatus,
    getOrderSummaryData,
    setOrderSummaryModalState,
} from 'src/pages/orders/redux/actions';
import { CommonEmptyBox } from 'src/styles/CommonStyles.styled';
import SurgeryOrderNonUsePopup from './review/components/SurgeryOrderNonUsePopup';
import UnidPlanPdfNotAvailable from '../scheduleSurgery/components/surgery/notifications/UnidPlanPdfNotAvailable';
import {
    checkIfOrderLockedFunc,
    unlockOrderFunc,
} from './redux/saga/dataServices';
import { SET_ITEMS_DURING_PRICING } from './redux/action/types';
import {
    ENVIRONMENTVARIABLE,
    MENU,
    REPORT_USAGE,
    VISIBLE,
} from 'src/constants/appConstants';
import {
    clearSingleDropDownList,
    getValidateAccountDetails,
    resetSurgeryDetails,
    resetValidateAccountDetails,
} from '../scheduleSurgery/redux/actions';
import AccountPhysicianTemplate from '../scheduleSurgery/components/details/AccountPhysicianTemplate';
import {
    resetNotes,
    setBannerDetails,
    setConfirmationBanner,
    setDestructive,
    setPediatricCheck,
    handleReportUsageNotes,
} from 'src/common/redux/actions';
import { useTranslation } from 'react-i18next';
import { clearValidateReplenData } from './redux/action/actionCreators';
import {UsageContainer, MultiViewComponent, SurgeryContainer, FindMaterialPopupContent, FindMaterialPopupMessage, FindMaterialPopupButtonContainer }  from './ReportUsagee.styled';
import onBlurImport from './utils/reportUsageUtil.js';
import updateStoredUnidInfoSurgeryDataUtil from './utils/updateStoredUnidInfoSurgeryDataUtil';
import { validateEmail } from './utils/reportUsageUtil.js';
import updateDiscrepancyReportUtil from './utils/updateDiscrepancyReportUtil';
import validateMazorKitCodeOnCTAbtnClickUtil from './utils/validateMazorKitCodeOnCTAbtnClickUtil';
import navigateToSpecifiedRPScreenUtil from './utils/navigateToSpecifiedRPScreenUtil.js';
import saveExitBtnClickHandlerUtil from './handlers/saveExitBtnClickHandlerUtil.js';
import discardChangesBtnClickHandlerUtil from './handlers/discardChangesBtnClickHandlerUtil.js';
import { useMazorCaseCoverageDropdown } from './hooks/useMazorCaseCoverageDropdown';
import { useReportUsageNotes } from './hooks/useReportUsageNotes';
import { useNotesCount } from './hooks/useNotesCount';
import { useReportUsageInit } from './hooks/useReportUsageInit';
import { usePediatricCheckEffect } from './hooks/usePediatricCheckEffect';
import { useOrderLockedEffect } from './hooks/useOrderLockedEffect';
import { useReportPaymentEffect } from './hooks/useReportPaymentEffect';
import { useBillToShipToPartnerRoleEffect } from './hooks/useBillToShipToPartnerRoleEffect';
import { useReportUsageFormObject } from './hooks/useReportUsageFormObject';
import { useAccountValidationEffect } from './hooks/useAccountValidationEffect';
import { useScrollingEffect } from './hooks/useScrollingEffect';
import { useScrollToTopEffect } from './hooks/useScrollToTopEffect';
import progressBarIconClickHandlerUtil from './handlers/progressBarIconClickHandlerUtil.js';
import priceOverrideResetAllClickHandlerUtil from './handlers/priceOverrideResetAllClickHandlerUtil.js';
import discardUNiDChangesBtnClickHandlerUtil from './handlers/discardUNiDChangesBtnClickHandlerUtil.js';
import applyBtnClickHandlerUtil from './handlers/applyBtnClickHandlerUtil.js';
import replenishBtnClickHandlerUtil from './handlers/replenishBtnClickHandlerUtil.js';
import reportPaymentBtnClickHandlerUtil from './handlers/reportPaymentBtnClickHandlerUtil.js';
import nextBtnClickHandlerUtil from './handlers/nextBtnClickHandlerUtil.js';
import submitBtnClickHandlerUtil from './handlers/submitBtnClickHandlerUtil.js';
import { useReportUsageEffect } from './hooks/useReportUsageEffect';
import { useFetchUsageDetailsEffect } from './hooks/useFetchUsageDetailsEffect';
import { useReportUsageDetailsEffect } from './hooks/useReportUsageDetailsEffect';
import { usePopulateProcedureEffect } from './hooks/usePopulateProcedureEffect';
import { useReportUsageFooterButtonsEffect } from './hooks/useReportUsageFooterButtonsEffect';
import warningModalCloseHandlerUtil from './handlers/warningModalCloseHandlerUtil.js';
import { useDiscrepancyEmailEffect } from './hooks/useDiscrepancyEmailEffect';
import { useReportPaymentBtnDisabledEffect } from './hooks/useReportPaymentBtnDisabledEffect';
import { usePriceOverrideReasonEffect } from './hooks/usePriceOverrideReasonEffect';
import { useInitialReportUsageLoadEffect } from './hooks/useInitialReportUsageLoadEffect';
import useRecordScreenEffect from './hooks/useRecordScreenEffect';
import useInitReportUsageEffect from './hooks/useInitReportUsageEffect';
import { useValidUnidProductsEffect } from './hooks/useValidUnidProductsEffect';
import { usePriceOverrideEffect } from './hooks/usePriceOverrideEffect';
import { useReportPaymentEffectt } from './hooks/useReportPaymentEffectt';
import { navigateToProcedureScreenUtil} from './utils/navigateToProcedureScreenUtil.js';
import { setProcedureDropdownUtil } from './utils/setProcedureDropdownUtil.js';
import submitUsageOrderUtil from './handlers/submitUsageOrderUtil';
import {usePriceOverrideApplyBtnEffect} from './hooks/usePriceOverrideApplyBtnEffect';
import {useReportUsageMountEffect} from './hooks/useReportUsageMountEffect';
import {useReplenishGridEffect} from './hooks/useReplenishGridEffect';
import {useReplenDraftOrderEffect} from './hooks/useReplenDraftOrderEffect';
import {useUnidProductsValidationEffect} from './hooks/useUnidProductsValidationEffect';
import {useMazorCodeValidationEffect} from './hooks/useMazorCodeValidationEffect';
import {useOrderSubmissionEffect} from './hooks/useOrderSubmissionEffect';
import {useBannerInfoEffect} from './hooks/useBannerInfoEffect';
import {useReplenRPGridEffect} from './hooks/useReplenRPGridEffect';
import { checkIfOrderIsSubmittedUtil } from './utils/checkIfOrderIsSubmitted';
import { validatingSerialAndQtyUtil } from './utils/validatingSerialAndQty';
import { storeUnidSurgeryLocalStateUtil } from './utils/storeUnidSurgeryLocalState';
import PopupContainer from 'src/pages/reportUsage/common/PopUpContainer';
import ReportUsagePopupContainer from 'src/pages/reportUsage/common/ReportUsagePopUpContainer';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import { handleSubmitReport } from 'src/common/components/floatingButton/components/handlers/ReportIssueFormHandler';
import ProgressBar from 'src/common/refactoredComponents/progressBar/ProgressBar';
import {setProgressBarStateEditMode} from 'src/pages/reportUsage/redux/action/actionCreators';
import { reportPaymentClicked } from './redux/action/actionCreators';
import CustomerCareNotes from 'src/common/refactoredComponents/customerCareNotes';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';


export const ReportUsageContext = React.createContext({});

import { isMobileDevice } from 'src/utils/util';

const ReportUsageContainer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const usageContainerRef = useRef();
    const countryCode = localStorage.getItem('countryISOCode');
    const saveAndExit = t('reportUsage.saveExit'); //?
    const cancel = t('reportUsage.reportUsageFooterbuttons.cancelButton');
    const replenish = t('reportUsage.reportUsageFooterbuttons.replenishButton');
    const review = t('reportUsage.reportUsageFooterbuttons.reviewButton');
    const next = t('scheduleSurgery.surgery.SurgeryFooter.nextBtn');
    const submit = t('noUsageToReport.submitButton');
    const procedure = t('reportUsage.progressBar.procedure');
    const apply = t('orders.orderListFilters.applyButton');
    const {replenDetails, procedureValue, steps, myCaseRefId, orderStatusDescription, procedureCodeFromSummary, orderBasicDetails,
        accounts, validateAccount, notes, vendorCaseId,
        mazorCaseCoverageEmployees, proceduresList, orderSummaryLoading, totalLevelsNumber, uivArray, livArray, reportPaymentClick
    } = useSelector((state)=>({
        replenDetails: state.reportUsageShippingDetailsReducer.gridData,
        procedureValue: state.reportUsageRootReducer?.procedureValue,
        steps: removePersistKey(state.reportUsageProgressBarReducer),
        myCaseRefId: state.reportUsageRootReducer.myCaseRefId || history.location.pathname.replace('/reportUsage/', ''),
        orderStatusDescription: state?.orderSummaryReducer?.orderBasicDetails?.orderStatusDescription,
        procedureCodeFromSummary: state?.orderSummaryReducer?.orderBasicDetails?.procedureDetail?.procedureCode,
        orderBasicDetails: state?.orderSummaryReducer?.orderBasicDetails,
        accounts: state.reportUsageRootReducer.dropdownData.accountLookup?.accounts || [],
        validateAccount:state.surgeryvalidateAccountReducer.validateAccount,
        notes: state.HeaderNotesReducer.reportUsageNotes?.[0],
        vendorCaseId: state.reportUsageRootReducer.usageDetails?.vendorCaseId,
        mazorCaseCoverageEmployees: state.detailsDropdownsReducer.mazorCaseCoverageEmployees?.items,
        proceduresList: state.reportUsageRootReducer.dropdownData.procedures &&
            state.reportUsageRootReducer.dropdownData.procedures.procedureList,
        orderSummaryLoading:  state.orderSummaryReducer.loading,
        totalLevelsNumber: state.reportUsageRootReducer.usageDetails.procedure?.levelUsed,
        uivArray: state.reportUsageRootReducer.usageDetails.procedure?.usedUIV,
        livArray: state.reportUsageRootReducer.usageDetails.procedure?.usedLIV,
        reportPaymentClick: state.reportUsageRootReducer.reportPaymentClicked,
    }));
    const {
        procedureDropdownValue: procedureDropdown, physicianDropdownValue, reportPaymentScreenName,
        levelDataModified, surgeryNumber, discrepancyUploadLoader, discrepancyEmailIds, discrepancyUsageValueExist,
        storedPatientDetails, localSignatureDetails: storedSignatureDetails, validatedReplenData, pricingNotes: storedPricingNotes,
        storedPriceOverrideReason, priceOverRideDetails, validateMazorCodeRes, kitCodeValidationInProgress, isProductsValidationInProgress,
        isPricingInProgress, reportUsageInProgress, usageOrderSubmission, validUnidProducts, validProducts, isPricingDone,
        discrepancyAttachment, storedItemTableData, itemTableData, isErrorFoundInFirstLevel, isErrorFoundInProcedure,
        procedureInfoDetails, usageDetailsLoading, usagePersistData, isConfirmationCheckboxChecked: isConfirmationChecked,
        isSubmitClicked, restrictReviewScreen, reportUsageObject, storedUnidSurgeryData, procedureData, fromOrdersList,
        isFromOrderDetailsModal, showUnsavedChangesPopup, navigationPath, selectedScreenToNavigate, usageDetails, discrepencyUpdatedDetails, surgeryData,
        dropDownLoading: isAccountsOptionLoading, pageLoading: isLoading, saveAndExitClick,
        physicianFieldText, physicianTextBoxType,
    } = useSelector((state) => state.reportUsageRootReducer);

    // Create wrapper functions to dispatch Redux actions
    const setPhysicianFieldText = (value) => {
        dispatch(setPhysicianTextData({ physicianFieldText: value }));
        // Update reportUsageFormObj with physician field text
        setReportUsageFormObj((prevStateObj) => ({
            ...prevStateObj,
            physicianFieldText: value,
        }));
    };
    
    const setPhysicianTextBoxType = (value) => {
        // When unknown is selected, clear the entered physician name and show unknown
        dispatch(
            setPhysicianTextData({
                physicianTextBoxType: value,
                ...(value === 'unknown' ? { physicianFieldText: '' } : {}),
            })
        );
       
        if (value === 'unknown') {
            setSelectedPhysicianData('unknown');
            dispatch(setPhysicianProcedureDropdownValue({ 
                physicianDropdownValue: 'unknown' 
            }));
            // Update reportUsageFormObj with physician data and clear entered name
            setReportUsageFormObj((prevStateObj) => ({
                ...prevStateObj,
                physicianTextBoxType: value,
                physicianFieldText: '',
            }));
        } else if (value === 'known') {
            setSelectedPhysicianData({});
            dispatch(setPhysicianProcedureDropdownValue({ 
                physicianDropdownValue: {} 
            }));
            // Update reportUsageFormObj with physician data
            setReportUsageFormObj((prevStateObj) => ({
                ...prevStateObj,
                physicianTextBoxType: value,
            }));
        }
    };

    const myCaseResourceType = useSelector(
        (state) =>
            state.reportUsageRootReducer.myCaseResourceType ||
            ((orderStatusDescription ===
                t('orders.orderStatuses.submittedPendingPriceOverride') ||
                orderStatusDescription ===
                    t('calendar.actionPanel.awaitingPO')) &&
                'reportPayment')
    );
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');
    
    const { configRule, pediatricSurgery, pediatricCheck, userDetailsLoading, bannerHeight,
        patientIdMandatory,
        reportUsagePatientDetails,
        reportUsagePatientDetailsMandatory,
        reportPaymentButtonVisibility,
        isLanguageChanged, billToShipToPartnerRole,
        procedureTypeUsageVisibility, procedurePageVisibility, priceOverrideReportUsageVisibility,
        procedureDataPhysician, salesOrg, replenishmentPageVisibilityUsage: rawReplenVisibility, signatureVisibilityUsage,
        priceOverrideReasonVisibilityUsage,
        priceOverrideReasonMandatoryUsage,
        priceOverrideCommentsVisibilityUsage,
        priceOverrideCommentsMandatoryUsage,
        notesVisibility,
        physicianTextUsageVisibility,
        hybrisUserDetails
    } = useSelector(
        (state) => state.loginReducer
    );
    const replenishmentPageVisibilityUsage = rawReplenVisibility === true || rawReplenVisibility === VISIBLE;

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );

    const REPORTPROGRESSTEPS =
        procedurePageVisibility && replenishmentPageVisibilityUsage
            ? REPORTPROGRESSTEP
            : procedurePageVisibility && !replenishmentPageVisibilityUsage
                ? REPORTPROGRESSTEPSWITHOUTREPLEN
                : !procedurePageVisibility && replenishmentPageVisibilityUsage
                    ? REPORTPROGRESSTEPSWITHOUTPROCEDURE
                    : REPORTPROGRESSTEPSWITHOUTREPLENANDPROCEDURE;

    const [usageDetailsFailureAlert, setUsageDetailsFailureAlert] =
        useState(false);

    const [footerButtonStatuses, setFooterButtonStatuses] = useState(
        initialButtonState()
    );
    const [currentActivity, setCurrentActivity] = useState(
        Object.keys(steps)
            .filter((step) => steps[step].current)
            .toString()
    );
    const [errForEmptyHrefIdField, setErrForEmptyHrefIdField] = useState(null);
    const [errForEmptyPatientField, setErrForEmptyPatientField] =
        useState(null);
    const [hasPopulatedProcedure, setHasPopulatedProcedure] = useState(false);
    const [pediatricDraftValue, setPediatricDraftValue] = useState(false);
    // state to get User Input for patient details
    const [patientDetails, setPatientDetail] = useState({
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
        patientSex: '',
        patientDOB: null,
    });
    const [showHidePricesBtn, setShowHidePricesBtn] = useState(false);
    const [toggleHidePricesBtn, setToggleHidePricesBtn] = useState('hideBtn');
    const [isPriceOverride, setPriceOverride] = useState(false);
    const [priceOverrideReason, setPriceOverrideReason] = useState('');
    const [pricingNotes, setPricingNotes] = useState('');
    const [priceOverrideTableData, setPriceOverrideTableData] = useState([]);
    const [reportPaymentFlag, setReportPaymentFlag] = useState(false);
    const [showReportPayment, setShowReportPayment] = useState(
        usagePersistData.showReportPayment
    );
    const [isRPPriceOverride, setRPPriceOverride] = useState(false);
    const [reportPaymentGridData, setReportPaymentGridData] = useState(
        usagePersistData.reportPayment
    );
    const [isReportPaymentBtnDisabled, setIsReportPaymentBtnDisabled] =
        useState(false);
    const [isReportPaymentScreen, setIsReportPaymentScreen] = useState(false);
    const [showCancelPopUp, setShowCancelPopUp] = useState(false);
    const [showUNiDPopUp, setShowUNiDPopUp] = useState(false);
    const [showSaveExitCompletionPopup, setShowSaveExitCompletionPopup] = useState(false);
    const [showFindMaterialPopup, setShowFindMaterialPopup] = useState(false);
    const [reportBtnClicked, setreportBtnClicked] = useState(false);
    // Request body/payload to create/update usage order
    const [reportUsageFormObj, setReportUsageFormObj] = useState({});
    const [showSurgeryNonUsePopup, setShowSurgeryNonUsePopup] = useState(false);
    const [advancedEnergyCheck, setAdvancedEnergyCheck] = useState(false);
    const [viewSurgeryNotes, setViewSurgeryNotes] = useState(false);
    const [notesCount, setNotesCount] = useState(0);
    const [isDraft, setDraft] = useState(false);
    const [emails, setEmails] = useState([]);
    const [unidSurgeryInfo, setUnidSurgeryInfo] = useState({});
    const [, setOrderLockedData] = useState({});
    const [showUnidInfoScreen, setShowUnidInfoScreen] = useState(false);
    const [unidInfoAlertPopup, setUnidInfoAlertPopup] = useState({});
    const [showORreportScreen, setShowORreportScreen] = useState(false);
    const [isReplishBtnClicked, setIsReplishBtnClicked] = useState(false);
    const [isProcedureBtnClicked, setIsProcedureBtnClicked] = useState(false);
    const [nextBtnClicked, setNextBtnClicked] = useState(false);
    const [procedureInfoData, setProcedureInfoData] = useState({});
    const [selectedPhysicianData, setSelectedPhysicianData] = useState({});
    const [procedureDropdownValue, setProcedureDropdownValue] = useState({});
    const [ temporaryProcedureDropdownValue, setTemporaryProcedureDropdownValue] = useState({});
    const [downArrow, setDownArrow] = useState({});
    const [selectedMazorCaseCoverage, setSelectedMazorCaseCoverage] = useState('');
    const [mazorCaseCoverageInputValue, setMazorCaseCoverageInputValue] = useState('');
    const [
        selectedStealthAxisCaseCoverage,
        setSelectedStealthAxisCaseCoverage,
    ] = useState('');
    const [
        stealthAxisCaseCoverageInputValue,
        setStealthAxisCaseCoverageInputValue,
    ] = useState('');
    const [replenGridData, setReplenGridData] = useState([]);
    const [replenRPGridData, setReplenRPGridData] = useState([]);
    const [shipAddress, setShipAddress] = useState(false);
    const [pdfNotAvailable, setPdfNotAvailable] = useState(false);
    const [lockLoader, setLockLoader] = useState(false);
    const [poFlag, setPOFlag] = useState(false);
    const [progressBarClicked, setProgressBarClicked] = useState(false);
    const [step, setStep] = useState('');
    const [rpInitialLoad, setRpInitialLoad] = useState(
        usagePersistData.submitButtonInitial
    );
    const [blockedAccountMessage, setBlockedAccountMessage] = useState(false);
    // state to maintain item table data
    const [filteredProduct, setFilteredProduct] = useState(
        Array.isArray(storedItemTableData) && storedItemTableData.length > 0
            ? storedItemTableData
            : []
    );
    const [emailInputBoxes, setEmailInputBoxes] = useState(discrepancyEmailIds);
    const [vendorCaseSstRefId, setVendorCaseSstRefId] = useState('');
    const [showOrderLockedPopup, setShowOrderLockedPopup] = useState({
        show: false,
        myCaseRef: null,
        modifiedBy: null,
    });
    const [loader, setloader] = useState(false);
    const [showBiologisDetails, setshowBiologisDetails] = useState(false);
    const [isAccountCardExpanded, setIsAccountCardExpanded] = useState(true);
    const [accountValue, setAccountValue] = useState('');
    const [updateUsageDetails, setIsUpdateUsageDetails] = useState(true);
    const [orderLockedDataValue, setOrderLockedDataValue] = useState();
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const resetReportUsageData = () => {
        dispatch(setPatientDetails({}));
        dispatch(resetProgressBarStatus());
        setFooterButtonStatuses(initialButtonState());
        setReportUsageFormObj({});
        setFilteredProduct([]);
        dispatch(storeItemTableData({}));
        dispatch(setLocalSignature({ base64Image: '', dateOfSignature: '' }));
        setShowReportPayment(false);
        setReportPaymentGridData([]);
        dispatch(setShippingDetails([]));
        dispatch(resetLevelData());
    };

    const validateAccountDetails = (accountId) => {
        REPORTUSAGEVALIDATEACCOUNT.sapPartnerId = accountId;
        dispatch(getValidateAccountDetails(REPORTUSAGEVALIDATEACCOUNT));
    };

    useEffectWithErrorLogging(()=>{
        setMyCaseRef(myCaseRefId);
        return ()=>{
            setMyCaseRef('');
        };
    },[]);

    useEffectWithErrorLogging(() => {
        if (
            patientDetails &&
            Object.values(patientDetails).length > 0 &&
            Object.values(patientDetails).some((x) => x?.length > 0)
        ) {
            dispatch({
                type: 'SET_LOCAL_PATIENT_DETAILS',
                payload: patientDetails,
            });
        }
    }, [patientDetails]);

    useEffectWithErrorLogging(() => {
        if (filteredProduct?.length >= 0) {
            dispatch({
                type: 'SET_LOCAL_USAGE_TABLE_DATA',
                payload: filteredProduct,
            });
            dispatch(storeItemTableData(filteredProduct));
        }
    }, [filteredProduct]);

    useEffectWithErrorLogging(() => {
        if (procedureInfoDetails) {
            Object.keys(procedureData).length > 0
                ? setProcedureInfoData({
                    ...procedureData,
                })
                : setProcedureInfoData({
                    ...procedureInfoDetails,
                });
        }
    }, [procedureInfoDetails]);

    // Hydrate physician text field & known/unknown radio from details API (once on load)
    const isPhysicianTextHydrated = useRef(false);
    useEffectWithErrorLogging(() => {
        if (
            physicianTextUsageVisibility === VISIBLE &&
            !usageDetailsLoading &&
            !isPhysicianTextHydrated.current &&
            usageDetails &&
            (usageDetails.physicianName || usageDetails.physicianId)
        ) {
            isPhysicianTextHydrated.current = true;
            const isOtherPhysician =
                usageDetails.physicianId === 'Other Physician';
            if (isOtherPhysician) {
                // Other Physician -> unknown radio, disabled field showing 'unknown'
                setPhysicianTextBoxType('unknown');
            } else if (usageDetails.physicianName) {
                // Real physician -> known radio, display the name
                setPhysicianTextBoxType('known');
                setPhysicianFieldText(usageDetails.physicianName);
            }
        }
    }, [usageDetailsLoading, physicianTextUsageVisibility, usageDetails]);

    const updateStoredUnidInfoSurgeryData = (unidSurgeryData, itemList) => {
        updateStoredUnidInfoSurgeryDataUtil(dispatch, unidSurgeryData, itemList);
    };

    useEffectWithErrorLogging(() => {
        if (configRule?.optionChosen === REPORT_USAGE) {
            !reportUsagePatientDetails?.includes('name')
                ? setPatientDetail((prev) => ({
                    ...prev,
                    patientFirstName: 'default',
                    patientLastName: 'default',
                }))
                : '';

            !reportUsagePatientDetails?.includes('href')
                ? setPatientDetail((prev) => ({
                    ...prev,
                    hrefId: 'default',
                }))
                : '';
        }
    }, [
        isPricingDone,
        procedureInfoDetails,
        currentActivity,
        filteredProduct,
        reportUsagePatientDetails,
        configRule,
    ]);

    // Arrow function to call the util and pass all required references
    const storeUnidSurgeryLocalState = () =>
        storeUnidSurgeryLocalStateUtil({
            unidSurgeryInfo,
            dispatch
        });

    const progressBarIconClickHandler = (step) => {
        progressBarIconClickHandlerUtil({ step, isDraft, procedureTypeUsageVisibility, proceduresList, dispatch, getDropdownOptionsRequest, procedureInfoDetails, usageDetails, salesOrg, setProcedureDropdownValue, getProcedureInfoRequest, setProgressBarClicked, setStep, patientDetails, filteredProduct, myCaseRefId, validateProductDetails, setPatientDetails });
    };

    const cancelBtnClickHandler = () => {
        setShowCancelPopUp(true);
        // setShowUNiDPopUp(false);
    };

    const priceOverrideResetAllClickHandler = () => {
        priceOverrideResetAllClickHandlerUtil({ setPricingNotes, setPriceOverrideReason, setPriceOverrideTableData, 
        priceOverrideTableData, setFooterButtonStatuses, footerButtonStatuses, cancel });
    };

    const closeCancelAlertPopup = () => {
        setVendorCaseSstRefId('');
        setShowCancelPopUp(false);
        setShowUNiDPopUp(false);
        setIsProcedureBtnClicked(false);
        setIsReplishBtnClicked(false);
        setNextBtnClicked(false);
        dispatch(setShowUnsavedReportUsageChangesPopUp(false));
    };

    const discardChangesBtnClickHandler = () => {
        discardChangesBtnClickHandlerUtil({
            isPriceOverride, setPriceOverride, setRPPriceOverride, dispatch, setPriceOverridePage, filteredProduct, 
            setPriceOverrideReason, setPricingNotes, reportUsageFormObj, priceOverRideDetails, myCaseResourceType, 
            setFilteredProduct, reportPaymentGridData, setPriceOverrideTableData, isProcedureBtnClicked, 
            isReplishBtnClicked, nextBtnClicked, setIsProcedureBtnClicked, setIsReplishBtnClicked, setNextBtnClicked, setReportPaymentScreenName, getModifiedButtonVisibilities, footerButtonStatuses, next, submit, setFooterButtonStatuses, procedurePageVisibility, screenSwitchOnReviewBtnClick, navigateToProcedureScreen,
            vendorCaseSstRefId, redirectToSpecifiedOrderForVendorCaseError, showReportPayment, setShowReportPayment, setReportPaymentGridData, storeUsageDataPresist, showUnsavedChangesPopup, navigationPath, history, getRoutePathWithParams, navLinkSelectHandler, selectedScreenToNavigate,
            setPediatricCheck, fromOrdersList, resetReportUsageData, resetReportUsageStates, resetNotes, unlockOrderFunc, setShowCancelPopUp, setShowUNiDPopUp, setShowUnsavedReportUsageChangesPopUp, myCaseRefId,
        });
    };

    const discardUNiDChangesBtnClickHandler = () => {
        discardUNiDChangesBtnClickHandlerUtil({ dispatch, setPatientDetails, patientDetails, patientIdMandatory, 
        filteredProduct, showReportPayment, myCaseRefId, getValidateItemsArr, 
        validateProductDetails, validateAccountDetails, usageDetails, myCaseResourceType, 
        reportPaymentGridData, getRPValidateItemsArr, isReplishBtnClicked, nextBtnClicked, 
        setIsReplishBtnClicked, setNextBtnClicked, setReportPaymentScreenName, 
        getModifiedButtonVisibilities, footerButtonStatuses, next, submit, 
        setFooterButtonStatuses, setShowUNiDPopUp });
    };

    const saveExitBtnClickHandler = async () => {
        await saveExitBtnClickHandlerUtil({
            t, setLockLoader, checkIfOrderIsSubmitted, myCaseRefId, setShowOrderLockedPopup,
            reportUsageFormObj, notes, usageDetails, showReportPayment, reportPaymentGridData,
            createReportPaymentSubmissionProductsArr, myCaseResourceType, getPriceInNumberDataType,
            discrepencyUpdatedDetails, currentActivity, storedItemTableData, emailInputBoxes,
            setEmailInputBoxes, setEmails, discrepancyAttachment, vendorCaseId, dispatch,
            createUsageOrderRequest, updateUsageOrderRequest, validateEmail, orderStatusDescription,
            adjustmentDisEnabled
        });
    };

    const setRPPriceOverrideData = (data) => {
        setPriceOverrideTableData(data);
    };

    const applyBtnClickHandler = () => {
        applyBtnClickHandlerUtil({
            priceOverrideTableData, priceOverrideReason, pricingNotes, setPriceOverrideTableData, dispatch, setPriceOverrideDetails,
            setFilteredProduct, getUpdatedPriceOverridenData, filteredProduct, setReportUsageFormObj, isRPPriceOverride, reportPaymentGridData,
            getPriceInNumberDataType, setReportPaymentGridData, setPriceOverride, setRPPriceOverride, setPriceOverridePage,
        });
    };

    const updateDiscrepancyReport = () => {
        updateDiscrepancyReportUtil({
            storedItemTableData,
            bundleHeadersArr,
            usageDetails,
            myCaseRefId,
            dispatch,
            putDisparencyData,
        });
    };

    const replenishBtnClickHandler = () => {
        replenishBtnClickHandlerUtil({ isReportPaymentScreen, reportPaymentButtonVisibility, reviewBtnClickHandler, setErrForEmptyHrefIdField, patientIdMandatory, reportUsagePatientDetailsMandatory, patientDetails, t, setErrForEmptyPatientField, reportUsagePatientDetails, filteredProduct, getValidateItemsArr, myCaseRefId, usageDetails, dispatch, validateProductDetails, validateUnidPlanFeeItems });
    };

    const navigateToProcedureScreen = () =>
        navigateToProcedureScreenUtil({dispatch,setProgressBarStatus,currentActivity,setCurrentActivity,REPORTPROGRESSTEPS,getModifiedButtonVisibilities,myCaseResourceType,
            footerButtonStatuses,procedure,usageDetails,t,review,
            setFooterButtonStatuses
        });
    useEffectWithErrorLogging(() => {
        if (procedureValue?.procedureCode?.length > 0) {
            setProcedureDropdownValue(procedureValue);
        }
    }, []);
    const procedureBtnClickHandler = () => {
        procedureBtnClickHandlerUtil({
            procedureTypeUsageVisibility,
            proceduresList,
            dispatch,
            getDropdownOptionsRequest,
            procedureInfoDetails,
            usageDetails,
            salesOrg,
            setProcedureDropdownValue,
            getProcedureInfoRequest,
            replenGridData,
            setIsProcedureBtnClicked,
            setShowCancelPopUp,
            navigateToProcedureScreen,
    replenishmentPageVisibilityUsage,
    replenishBtnClickHandler
        });
    };

    const validateMazorKitCodeOnCTAbtnClick = (clickedBtn) => {
        validateMazorKitCodeOnCTAbtnClickUtil({
            procedureInfoData,
            validateMazorCodeRes,
            dispatch,
            validateMazorCodeRequest,
            clickedBtn,
        });
    };

    const screenSwitchOnReviewBtnClick = () => {
        dispatch(setIsConfirmationChecked(false));
        setShowUnidInfoScreen(false);
        setShowORreportScreen(false);
        dispatch(setProgressBarStatus(currentActivity));
        !procedurePageVisibility && dispatch(setProgressBarStatus('Procedure'));
        setCurrentActivity(
            REPORTPROGRESSTEPS[
                REPORTPROGRESSTEPS.findIndex(
                    (activity) => activity === currentActivity
                ) + 1
            ]
        );
        const modifiedButtonStatuses = getModifiedButtonVisibilities(
            myCaseResourceType,
            footerButtonStatuses,
            review,
            submit
        );
        setFooterButtonStatuses(
            modifiedButtonStatuses.map((button) =>
                button.btnName === submit
                    ? { ...button, isBtnDisable: true }
                    : button
            )
        );
    };

    const screenSwitchOnUnidInfoBtnClick = () => {
        setShowUnidInfoScreen(true);
        document.getElementById('UsageContainer')?.scrollTo(0, 0);
        const modifiedButtonStatuses = getModifiedButtonVisibilities(
            myCaseResourceType,
            footerButtonStatuses,
            t('reportUsage.progressBar.UNiDInfo'),
            t('reportUsage.reportUsageFooterbuttons.orReportButton')
        );
        setFooterButtonStatuses(modifiedButtonStatuses);
    };

    const unidInfoBtnClickHandler = () => {
        if (validateMazorCodeRes?.statusCode === 'draft') {
            validateMazorKitCodeOnCTAbtnClick('unidInfo');
        } else {
            screenSwitchOnUnidInfoBtnClick();
        }
    };

    const ORreportBtnClickHandler = () => {
        if (showUnidInfoScreen && Object.keys(unidSurgeryInfo).length > 0) {
            storeUnidSurgeryLocalState();
        }
        setShowUnidInfoScreen(false);
        setShowORreportScreen(true);
        document.getElementById('UsageContainer')?.scrollTo(0, 0);
        const modifiedButtonStatuses = getModifiedButtonVisibilities(
            myCaseResourceType,
            footerButtonStatuses,
            t('reportUsage.reportUsageFooterbuttons.orReportButton'),
            review
        );
        setFooterButtonStatuses(modifiedButtonStatuses);
    };

    const reviewBtnClickHandler = () => {
        reviewBtnClickHandlerUtil({
            dispatch,
            setProcedureData,
            procedureInfoData,
            vendorCaseId,
            usageDetails,
            myCaseResourceType,
            updateDiscrepancyReport,
            showReportPayment,
            reportPaymentGridData,
            myCaseRefId,
            getRPValidateItemsArr,
            validateProductDetails,
            setFilteredProduct,
            setProgressBarStatus,
            currentActivity,
            REPORTPROGRESSTEPS,
            getModifiedButtonVisibilities,
            footerButtonStatuses,
            review,
            submit,
            setFooterButtonStatuses,
            setShowReportPayment,
            showUnidInfoScreen,
            unidSurgeryInfo,
            storeUnidSurgeryLocalState,
            validateMazorCodeRes,
            validateMazorKitCodeOnCTAbtnClick,
            replenGridData,
            procedurePageVisibility,
            setIsProcedureBtnClicked,
            setShowCancelPopUp,
            screenSwitchOnReviewBtnClick,
            setCurrentActivity,
            replenishmentPageVisibilityUsage
        });
    };

    const warningModalCloseHandler = () => {
        warningModalCloseHandlerUtil({
            setUsageDetailsFailureAlert, setShowSaveExitCompletionPopup, usageDetailsFailureAlert, usageOrderSubmission,
            isFromOrderDetailsModal, dispatch, setOrderStatus, getOrderSummaryData, setOrderSummaryModalState, myCaseRefId,
            history, fromOrdersList, getRoutePathWithParams, resetReportUsageData, resetReportUsageStates, resetNotes,
            unlockOrderFunc, myCaseResourceType
        });
    };

    const { surgeryDetails } = useSelector((state) => ({
        surgeryDetails: state.reportShipToAddressReducer.insideSurgeryDetails,
    }));

    const adjustmentDisEnabled = useSelector(
        (state) => state.loginReducer?.hybrisUserDetails?.adjustmentDisEnabled
    );

    // Adj notes section is shown based on the adj flag alone (like the Adj label);
    // notes typed without an adj qty are kept and simply excluded from the submit
    // payload (see submitUsageOrderUtil/saveExitBtnClickHandlerUtil), with a
    // warning shown on the review/submit screen.

    const submitUsageOrder = (reportPaymentRequestObj, orderLockData) =>
        submitUsageOrderUtil({reportPaymentRequestObj,orderLockData,setShowSurgeryNonUsePopup,usageDetails, 
        reportUsageFormObj,getPriceInNumberDataType,notes,dispatch,createUsageOrderRequest,updateUsageOrderRequest, 
        myCaseResourceType,setLockLoader,showReportPayment,storeUsageDataPresist, setEmails,emailInputBoxes, 
        setEmailInputBoxes, validateEmail, t,vendorCaseId,discrepancyAttachment,pediatricSurgery,pediatricCheck,
        setSubmitClicked,discrepencyUpdatedDetails,storedItemTableData, orderStatusDescription, adjustmentDisEnabled
    });

    const submitBtnClickHandler = async () => {
        if(loader) return;
        setloader(true);
        await submitBtnClickHandlerUtil({
            dispatch, setLockLoader, checkIfOrderIsSubmitted, setOrderLockedData,setShowOrderLockedPopup, 
            myCaseRefId, myCaseResourceType, showReportPayment,reportPaymentGridData, setFooterButtonStatuses, 
            footerButtonStatuses, submit, createReportPaymentSubmissionProductsArr, reportUsageFormObj, 
            setReportUsageFormObj,submitUsageOrder, usageDetails, setShowSurgeryNonUsePopup, next
        });
        setloader(false);
    };

    useEffectWithErrorLogging(() => {
        const value = {
            procedureCode: usageDetails?.procedureCode,
            procedureDescription: usageDetails?.procedureDescription,
        };
        usageDetails?.procedureCode && setProcedureDropdownValue(value);
    }, [usageDetails?.procedureCode]);

    // Arrow function to call the util and pass all required references
    const checkIfOrderIsSubmitted = async (editStatus) =>
        checkIfOrderIsSubmittedUtil({
            myCaseResourceType,
            myCaseRefId,
            getOrderLockedAction,
            checkIfOrderLockedFunc,
            editStatus
        });
    
    const closeOrderLockedPopup = () => {
        setShowOrderLockedPopup({
            show: false,
            myCaseRef: null,
            modifiedBy: null,
        });
    };

    const defaultBtnClickHandler = () => {
    };

    const reportPaymentBtnClickHandler = () => {
    // If you need to call validatingSerialAndQty, do it here before util if needed
        reportPaymentBtnClickHandlerUtil({ reportPaymentButtonVisibility, dispatch, reportUsageFormObj, 
            setShowReportPayment, setReportPaymentGridData, setCurrencyFormat, itemTableData, 
            isValidLotSerial, showUnidInfoScreen, storeUnidSurgeryLocalState, validatingSerialAndQty });
    };

    // Arrow function to call the util and pass all required references
    const validatingSerialAndQty = () => validatingSerialAndQtyUtil({ myCaseResourceType, showReportPayment, 
        itemTableData, myCaseRefId, usageDetails, getValidateItemsArr, setReportPaymentFlag, dispatch, 
        validateProductDetails });

    const navigateToSpecifiedScreen = (screen) => {
        usageContainerRef.current?.scrollTo(0, 0);
        dispatch(setProgressBarCurrentStep(screen));
        setCurrentActivity(screen);
        const modifiedButtonStatuses = getModifiedButtonVisibilities(
            myCaseResourceType,
            footerButtonStatuses,
            currentActivity === 'Submit'
                ? review
                : t('reportUsage.reportUsageFooterbuttons.orReportButton'),
            screen === 'Replen'
                ? procedure
                : screen === 'Procedure'
                    ? usageDetails &&
            usageDetails.unidId &&
            usageDetails?.unidSurgeryInfoPage?.deliveredRodItems?.length > 0
            ? t('reportUsage.progressBar.UNiDInfo') : review
                    : replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review,
            true
        );
        setFooterButtonStatuses(modifiedButtonStatuses);
        setShowORreportScreen(false);
        setShowUnidInfoScreen(false);
    };

    const navigateToSpecifiedRPScreen = (screen, isBackButton) => {
        navigateToSpecifiedRPScreenUtil({
            screen, isBackButton, reportPaymentGridData, usageContainerRef, dispatch, setReportPaymentScreenName,
            getModifiedButtonVisibilities, myCaseResourceType, footerButtonStatuses, reportPaymentScreenName,
            submit, next, setFooterButtonStatuses, replenishmentPageVisibilityUsage,
        });
    };
    const openUNIDLinks = () => {
        const { unidIdURL } = usageDetails;
        if (unidIdURL === 'EmptyUrl' || !unidIdURL) {
            setPdfNotAvailable(true);
        } else {
            const urls = unidIdURL.split('*#*').filter((url) => url);
            urls.forEach((url) => {
                window.open(url);
            });
        }
    };
    const redirectToSpecifiedOrderForVendorCaseError = (
        vendorCaseMyCaseRefId
    ) => {
        history.push(
            fromOrdersList
                ? getRoutePathWithParams('/orders')
                : getRoutePathWithParams('/')
        );
        (myCaseRefId && myCaseRefId?.length > 0) && unlockOrderFunc({
            action:
                myCaseResourceType === 'reportPayment'
                    ? 'ReportPayment'
                    : myCaseResourceType === 'draft'
                        ? 'DraftUsageEdit'
                        : 'ReportUsage',
            myCaseRefId: myCaseRefId,
        });
        resetReportUsageData();
        dispatch(resetReportUsageStates());
        dispatch(resetNotes());
        dispatch(setOrderStatus({ orderStatus: '' }));
        dispatch(getOrderSummaryData());

        dispatch(
            setOrderSummaryModalState({
                myCaseRef: vendorCaseMyCaseRefId,
                orderSummaryModal: true,
            })
        );
        localStorage.removeItem('myCaseRefUsage');
    };

    const nextBtnClickHandler = () => {
        nextBtnClickHandlerUtil({
            reportPaymentScreenName, myCaseResourceType, showReportPayment, reportPaymentGridData,
            myCaseRefId, getRPValidateItemsArr, dispatch, validateProductDetails, usageDetails, validateUnidPlanFeeItems,
            replenRPGridData, setIsProcedureBtnClicked, setNextBtnClicked, setShowCancelPopUp, setReportPaymentScreenName,
            getModifiedButtonVisibilities, footerButtonStatuses, next, submit, setFooterButtonStatuses,
        });
    };

    const onFlagChange = (flagValue) => {
        setPOFlag(flagValue);
    };

    const showCancelPopupOnVendorCaseIdHandler = (
        vendorCaseMyCaseRefId,
        isShowDiscardPopup,
        isDraftPopup
    ) => {
        if (isShowDiscardPopup) {
            setVendorCaseSstRefId(vendorCaseMyCaseRefId);
            setShowCancelPopUp(true);
        } else {
            if (isDraftPopup) {
                setUsageDetailsFailureAlert(false);
                setShowSaveExitCompletionPopup(false);
            }
            redirectToSpecifiedOrderForVendorCaseError(vendorCaseMyCaseRefId);
        }
    };

    const setProcedureDropdown = (value, flag = false) =>
        setProcedureDropdownUtil({value,flag,
            setDownArrow,reportUsageObject,setProcedureDropdownValue,resetProcedurePage,procedureTypeUsageVisibility,salesOrg,setDraft,dispatch,setProcedureValue,getProcedureInfoRequest,setTemporaryProcedureDropdownValue, procedureDropdownValue, isDraft, usageDetails
        });


    const setPhysicianDropdown = (value) => {
        setSelectedPhysicianData(value);
        dispatch(
            setPhysicianProcedureDropdownValue({
                physicianDropdownValue: value,
            })
        );
    };

    const removePricingDetails = () =>
        removePricingDetailsUtil({
            setFilteredProduct,
            deletePricingDetails,
            filteredProduct,
            setPricingNotes,
            dispatch,
            setPriceOverrideReason,
            SET_ITEMS_DURING_PRICING
        });

    const removeShippingDetails = () => {
        const modifiedData = replenGridData.map((item) => ({
            ...item,
            shippingDetails: null,
        }));
        setReplenGridData(modifiedData);
        dispatch(setShippingDetails(modifiedData));
    };

    const handleInputChange = (name, value) => {
        const object = {
            [name]: value,
        };
        if (
            name == 'accountId' &&
            value != '' &&
            value.errorMessage == undefined
        ) {
            validateAccountDetails(value.accountId);
            removePricingDetails();
            removeShippingDetails();
            dispatch(resetProgressBarStatus());
            setAccountValue(value?.accountFormattedName || '');
        }

        setReportUsageFormObj((prevStateObj) => ({
            ...prevStateObj,
            ...object,
            isChangeAccount: true,
            updatedZLBAccount: value.accountId,
            isChangedFromDefaultAccount: value
                ? value.accountId === usageDetails?.accountId
                    ? false
                    : true
                : reportUsageFormObj?.isChangedFromDefaultAccount,
        }));
        dispatch(
            editUsageDetails({
                accountId: value.accountId,
                accountName: value.accountName,
                accountFormattedName: value.accountFormattedName,
            })
        );
    };

    const resetProcedurePage = () => {
        dispatch({
            type: SET_ADVANCE_ENERGY_DATA,
            payload: {},
        });
        setshowBiologisDetails(false);
        dispatch(resetLevelData());
        dispatch(resetMazxorCaseCoverage(''));
        dispatch(resetStealthCaseCoverage(''));
        setSelectedMazorCaseCoverage('');
        setMazorCaseCoverageInputValue('');
        setSelectedStealthAxisCaseCoverage('');
        setStealthAxisCaseCoverageInputValue('');
        setAdvancedEnergyCheck(false);
        dispatch(setRetractorUsedOtherField(''));
    };

    const onBlur = (event) => {
        onBlurImport({
            event, usageDetails, reportUsageFormObj, dispatch, editUsageDetails, setReportUsageFormObj,
            validateAccountDetails, setAccountValue, removePricingDetails,
            removeShippingDetails, resetProgressBarStatus,
        });
    };

    const AccountTemplate = (option, fieldname) => {
        return (
            <AccountPhysicianTemplate
                option={option}
                // eslint-disable-next-line no-undef
                data={accounts}
                optionValue={'accountId'}
                fieldname={fieldname}
            />
        );
    };

    const handleOnfocus = (event, field) => {
        if (field == 'accounts') {
            dispatch(
                getDropdownOptionsRequest('accountLookup', {
                    accountName: event?.target?.value?.trim() || '',
                })
            );
        }
    };

    const debouncedAccountList = useRef(
        debounce((option) => {
            dispatch(getDropdownOptionsRequest('accountLookup', option));
        }, 500)
    ).current;

    const handleSearch = (event, value, reason, fieldname) => {
        if (reason !== 'reset') {
            let option = {
                accountName: value?.trim() || '',
            };
            if (fieldname == 'account') {
                setAccountValue(value);
                debouncedAccountList(option);
            }
        } else if (reason === 'reset' && value === '') {
            setAccountValue(value);
        }
    };
    const handleClosePopUp = () => {
        let surgeryDetailsValue = {};
        setAccountValue('');
        setBlockedAccountMessage(false);
        surgeryDetailsValue['accountId'] = '';
    };

    const handleCloseOrderLockPopup = () => {
        localStorage.removeItem('myCaseRefUsage');
        resetReportUsageData();
        dispatch(resetReportUsageStates());
        dispatch(resetNotes());
        (myCaseRefId && myCaseRefId?.length > 0) && unlockOrderFunc({
            action: 'ReportPayment',
            myCaseRefId: myCaseRefId,
        });
        history.push(getRoutePathWithParams('/orders'));
    };

    const getViewBasedOnTemplate = (viewSurgeryNotes) => {
        if (viewSurgeryNotes) {
            return (
                <CustomerCareNotes
                    header={t('reportUsage.customerCareNotes')}
                    setViewNotes={setViewSurgeryNotes}
                    setNotesCount={setNotesCount}
                    noteOneHeader={t('common.newUsageNote')}
                    noteTwoHeader={t('common.newReplenishNote')}
                    noteOneSubHeader={t('reportUsage.usageNotes')}
                    noteTwoSubHeader={t('common.replenishmentNotes')}
                    isFromReportUsage={true}
                    notesVisibility={notesVisibility}
                />
            );
        }
    };

    const {
        showBackDrop,
        showFooter,
        showProcedureScreen,
        showProgressBar,
        showSurgeryORReport,
        showRecordScreen,
        showReplenScreen,
        showSubHeader,
        showUnidSurgeryInfoScreen,
        showReportPaymentButton,
        showSubmitScreen,
        showReviewScreen,
        showSpinner,
        showWarningModel,
    } = useReportUsageScreenRenders({
        viewSurgeryNotes,
        usageDetailsLoading,
        orderSummaryLoading,
        discrepancyUploadLoader,
        lockLoader,
        userDetailsLoading,
        myCaseResourceType,
        reportUsageInProgress,
        isSubmitClicked,
        usageDetails,
        isPriceOverride,
        showReportPayment,
        usageOrderSubmission,
        currentActivity,
        restrictReviewScreen,
        showUnidInfoScreen,
        showORreportScreen,
        reportPaymentButtonVisibility,
        procedurePageVisibility,
        countryCode,
        isPricingInProgress,
        isProductsValidationInProgress,
        kitCodeValidationInProgress,
        usageDetailsFailureAlert,
        showSaveExitCompletionPopup,
        isLoading,
    });

    const getFooterButtonLabel = (currentActivity) => {
        if (!procedurePageVisibility && !replenishmentPageVisibilityUsage) {
            // Neither visible
            return currentActivity === 'Submit'
                ? submit
                : currentActivity === 'Record'
                    ? review
                    : review;
        } else if (!procedurePageVisibility && replenishmentPageVisibilityUsage) {
            // Only replenishment visible
            return currentActivity === 'Submit'
                ? submit
                : currentActivity === 'Record'
                    ? replenish
                    : review;
        } else if (procedurePageVisibility && !replenishmentPageVisibilityUsage) {
            // Only procedure visible
            return currentActivity === 'Submit'
                ? submit
                : currentActivity === 'Record'
                    ? procedure
                    : review;
        } else {
            // Both visible
            return REPORTUSAGEBUTTON()[
                REPORTPROGRESSTEPS.findIndex(
                    (activity) => activity === currentActivity
                )
            ];
        }
    };

    useReportUsageMountEffect({
        setFilteredProduct,
        dispatch,
        resetReportUsageData,
        MENU,
        clearSingleDropDownList,
        resetNotes,
        resetSurgeryDetails,
        resetValidateAccountDetails,
        resetReportUsageStates,
        unlockOrderFunc,
        myCaseRefId,
        myCaseResourceType,
    });

    // Optimized and readable computation for procedure dropdown value selection
    const hasProcedureCode = !!usageDetails?.procedureCode && usageDetails?.procedureCode?.length > 0;
    const shouldUseUsageDetailsProcedure = hasProcedureCode && !(isDraft && usageDetails?.isProcedureReq);
    const procedureValueComputed = shouldUseUsageDetailsProcedure
        ? {
              procedureCode: usageDetails?.procedureCode,
              procedureDescription: usageDetails?.procedureDescription,
          }
        : downArrow
            ? temporaryProcedureDropdownValue
            : procedureDropdownValue;

    useInitReportUsageEffect({
        isSubmitClicked, myCaseResourceType, restrictReviewScreen, setPhysicianDropdown, physicianDropdownValue, 
        setProcedureDropdown, procedureValue: procedureValueComputed
, setProcedureData, procedureData, setPriceOverrideReason, 
        storedPriceOverrideReason, setPricingNotes, storedPricingNotes, footerButtonStatuses, 
        getModifiedButtonVisibilities, replenish, currentActivity, REPORTPROGRESSTEPS, usageDetails, 
        storedItemTableData, t, procedurePageVisibility, submit, review, setFooterButtonStatuses, 
        isConfirmationChecked, itemTableData, getReplenNonTissueItems, replenDetails, setReplenGridData, 
        getTotalQuantity, storedUnidSurgeryData, setUnidSurgeryInfo, setReportUsageFormObj, reportUsageObject, 
        setReplenRPGridData, replenishmentPageVisibilityUsage, procedure, showReportPayment, getFooterButtonLabel
    });

    usePediatricCheckEffect({
        usageDetails,
        dispatch,
        setPediatricDraftValue,
        setPediatricCheck,
    });
    useReportUsageInit({
        dispatch,
        getOrderSummaryData,
        myCaseResourceType,
    });

    useNotesCount({ notes, setNotesCount });

    useReportUsageNotes({ usageDetails, dispatch});

    useMazorCaseCoverageDropdown({ myCaseRefId, dispatch});

    useOrderLockedEffect({ orderLockedDataValue, usageOrderSubmission, setShowOrderLockedPopup, dispatch, 
        setOrderSummaryModalState, history });

    useRecordScreenEffect({
        validProducts, filteredProduct, showReportPayment, getValidatedItemTableData, myCaseResourceType,
        setFilteredProduct, checkIfValidProductsInRecordScreen, patientDetails, patientIdMandatory, progressBarClicked,
        dispatch, setProgressBarStatus, currentActivity, setCurrentActivity, REPORTPROGRESSTEPS,
        getModifiedButtonVisibilities, footerButtonStatuses, replenish, review, procedure, updateStoredUnidInfoSurgeryData,
        storedUnidSurgeryData, step, showUnidInfoScreen, unidSurgeryInfo, storeUnidSurgeryLocalState, steps,
        showORreportScreen, submit, usageDetails, t, cancel, saveAndExit, setFooterButtonStatuses,
        setShowORreportScreen, setShowUnidInfoScreen, procedurePageVisibility, setProgressBarCurrentStep, replenishmentPageVisibilityUsage, 
        getDropdownOptionsRequest, setProcedureDropdownValue,getProcedureInfoRequest,navigateToProcedureScreen 
    });

    useValidUnidProductsEffect({
        validUnidProducts, filteredProduct, showReportPayment, getValidatedItemTableData, myCaseResourceType, 
        setFilteredProduct, setIsReplishBtnClicked, setShowUNiDPopUp, patientIdMandatory, patientDetails, myCaseRefId, 
        getValidateItemsArr, dispatch, validateProductDetails
    });

    useReportPaymentEffect({
        orderStatusDescription, usageOrderSubmission, setShowReportPayment, dispatch, fetchUsageDetailsRequest, history, t,
    });

    // FINDMATERIAL check - show popup and trigger report issue API
    useEffectWithErrorLogging(() => {
        if (
            !showFindMaterialPopup &&
            showReportPayment &&
            usageDetails?.products?.length > 0 &&
            usageDetails.products.some((product) => product.productCFN === 'FINDMATERIAL' || product.productCFN === 'TEMP')
        ) {
            setShowFindMaterialPopup(true);
            localStorage.setItem('myCaseRefId', usageDetails.myCaseRef || myCaseRefId);
            handleSubmitReport({
                issueDescription: 'Payment not applied: 82 FINDMATERIAL Block active in SAP.',
                attachedFiles: [],
                userDetails: hybrisUserDetails,
                emailCopy: true,
                setEmailCopy: () => {},
                setIsSubmitting: () => {},
                setShowSuccessMessage: () => {},
                setIssueDescription: () => {},
                setAttachedFiles: () => {},
            });
        }
    }, [usageDetails, showReportPayment]);

    useBillToShipToPartnerRoleEffect(billToShipToPartnerRole);

    useReportUsageFormObject({reportUsageFormObj,dispatch,setReportUsageFormObject,});

    useAccountValidationEffect({ usageDetails, validateAccount, reportUsageFormObj, dispatch, 
        setSelectedOutsideAccount, editUsageDetails });

    useScrollingEffect({ showCancelPopUp, showUnsavedChangesPopup, showSaveExitCompletionPopup, 
        showSurgeryNonUsePopup, showUNiDPopUp, hideScrolling, resumeScrolling });

    useScrollToTopEffect({
        usageContainerRef, currentActivity, isPriceOverride, showReportPayment,
        showUnidInfoScreen, showORreportScreen, reportPaymentScreenName,
    });
    useReportUsageEffect({
        myCaseResourceType,
        surgeryData,
        currentActivity,
        setShowReportPayment,
        setReportPaymentGridData,
        setCurrentActivity,
        getModifiedButtonVisibilities,
        footerButtonStatuses,
        replenish,
        reportPaymentScreenName,
        submit,
        next,
        setFooterButtonStatuses,
        procedureCodeFromSummary,
        salesOrg,
        orderStatusDescription,
        t,
        setDraft,
        dispatch,
        procedurePageVisibility,
        review,
        replenishmentPageVisibilityUsage,
        procedure,
        sapPartnerId: orderBasicDetails?.accountNumber
    });

    useFetchUsageDetailsEffect({
        myCaseRefId, myCaseResourceType, usageDetails, orderStatusDescription, orderBasicDetails, dispatch,
        resetLevelData, fetchUsageDetailsRequest, getDropdownOptionsRequest, reportPaymentClick, reportPaymentClicked
    });

    useReportUsageDetailsEffect({
        usageDetails,
        myCaseRefId,
        updateUsageDetails,
        setIsUpdateUsageDetails,
        setUsageDetailsFailureAlert,
        setPatientDetail,
        patientDetails,
        storedPatientDetails,
        setPriceOverrideReason,
        setReportUsageFormObj,
        setPricingNotes,
        validateAccountDetails,
        setAccountValue,
        dispatch,
        procedureTypeUsageVisibility,
        VISIBLE,
        setProcedureDropdown,
        setPhysicianDropdown,
        myCaseResourceType,
        t,
        usagePersistData,
        setReportPaymentGridData,
        setFilteredProduct,
        setReplenGridData,
        setLocalSignature,
        reportUsageFormObj,
        reportUsagePatientDetails,
        countryCode,
        storeUsageDataPresist,
        modifyDraftProductsResponse,
        getPatientDetailsInDraftOrder,
        currentActivity,
        getProgressBarStateOnLoad,
        orderStatusDescription, // <-- Add this line
        setPatientDetails,
        getValidReplenishGridData,
        generate_UUID,
        physicianTextUsageVisibility,
    });

    usePopulateProcedureEffect({
        hasPopulatedProcedure, setHasPopulatedProcedure, usageDetails, procedureInfoData, setProcedureInfoData,
        dispatch, levelDataModified, modifyDraftProcedureDataResponse, setRetractorUsedOtherField, mazorCaseCoverageEmployees,
        setMazorCaseCoverageValue, setSelectedMazorCaseCoverage, setMazorCaseCoverageInputValue, setStealthCaseCoverageValue, setSelectedStealthAxisCaseCoverage,
        setStealthAxisCaseCoverageInputValue, addProcedureLevel, setUivDropdownValue, setLivDropdownValue, setProcedureData,
        reportUsageFormObj, setReportUsageFormObj, createProcedureDraftOrderObject, uivArray, livArray, totalLevelsNumber,
    });

    useReportUsageFooterButtonsEffect({
        showReportPayment,
        myCaseResourceType,
        dispatch,
        setIsErrorExist,
        checkIfValidData,
        itemTableData,
        setFooterButtonStatuses,
        footerButtonStatuses,
        cancel,
        saveAndExit,
        replenish,
        isReportPaymentScreen,
        errForEmptyHrefIdField,
        errForEmptyPatientField,
        patientIdMandatory,
        reportUsagePatientDetails,
        reportUsagePatientDetailsMandatory,
        usageDetails,
        patientDetails,
        isPricingDone,
        filteredProduct,
        t,
        checkIfValidPricedItems,
        toggleHidePricesBtn,
        toggleSaveExitButton,
        isErrorFoundInProcedure,
        isErrorFoundInFirstLevel,
        currentActivity,
        countryCode,
        createRecordAndReplenDraftOrderObj,
        replenGridData,
        reportUsageFormObj,
        surgeryNumber,
        priceOverrideReason,
        pricingNotes,
        setReportUsageFormObj,
        resetProgressBarStatus,
        showCancelPopUp,
        replenishmentPageVisibilityUsage,
        procedurePageVisibility,
        procedure,
        review
    });

    useDiscrepancyEmailEffect({ discrepancyUsageValueExist, discrepencyUpdatedDetails, dispatch, 
        setDiscrepancyUsageValueExist, emailInputBoxes, setEmailInputBoxes, setDiscrepancyEmailIds, myCaseRefId });

    useReportPaymentBtnDisabledEffect({
        footerButtonStatuses,
        t,
        setIsReportPaymentBtnDisabled,
    });

    usePriceOverrideReasonEffect({
        filteredProduct,
        storedPriceOverrideReason,
        setPriceOverrideReason,
        priceOverrideReason,
    });

    useInitialReportUsageLoadEffect({ storedItemTableData, setFilteredProduct, storedPriceOverrideReason, 
        storedPricingNotes, setPriceOverrideReason, setPricingNotes, storedPatientDetails, 
        setPatientDetail, dispatch, setPatientDetails, storedSignatureDetails, setLocalSignature });

    usePriceOverrideEffect({
        isPriceOverride,
        myCaseResourceType,
        setPriceOverrideTableData,
        filteredProduct,
        getModifiedButtonVisibilities,
        footerButtonStatuses,
        showReportPayment,
        replenish,
        setFooterButtonStatuses,
        dispatch,
        setPriceOverridePage,
        reportPaymentScreenName,
        review,
        next,
        submit,
        replenishmentPageVisibilityUsage,
        procedurePageVisibility,
        procedure,
        apply,
        currentActivity,
        usageDetails
    });

    useReportPaymentEffectt({
        validProducts,
        reportPaymentGridData,
        showReportPayment,
        reportUsageFormObj,
        getRPValidatedItemTableData,
        countryCode,
        setReportPaymentGridData,
        checkIfValidReportPaymentData,
        getProductsArrFromReportPaymentFlow,
        myCaseResourceType,
        setFooterButtonStatuses,
        footerButtonStatuses,
        next,
        createReportPaymentSubmissionProductsArr,
        submit,
        setReportUsageFormObj,
        dispatch,
        setReportPaymentScreenName,
        getModifiedButtonVisibilities,
        reportPaymentButtonVisibility,
        VISIBLE,
        procedurePageVisibility,
        replenish,
        review,
        modifyDraftProductsResponse,
        usageDetails,
        setFilteredProduct,
        progressBarClicked,
        reportPaymentFlag,
        currentActivity,
        setCurrentActivity,
        REPORTPROGRESSTEPS,
        setShowReportPayment,
        updateStoredUnidInfoSurgeryData,
        storedUnidSurgeryData,
        setReportPaymentFlag,
        setProgressBarStatus,
        procedure,
        replenishmentPageVisibilityUsage
    });
    usePriceOverrideApplyBtnEffect({
        isPriceOverride,
        priceOverrideTableData,
        setFooterButtonStatuses,
        footerButtonStatuses,
        cancel,
        isPriceOverrideApplyBtnDisabled,
        priceOverrideReason,
        pricingNotes,
        priceOverrideReasonVisibilityUsage,
        priceOverrideReasonMandatoryUsage,
        priceOverrideCommentsVisibilityUsage,
        priceOverrideCommentsMandatoryUsage
    });
    // usePriceOverrideApplyBtnEffect({ isPriceOverride, priceOverrideTableData, setFooterButtonStatuses, 
    //     footerButtonStatuses, cancel, isPriceOverrideApplyBtnDisabled, priceOverrideReason, pricingNotes });

    

    useReplenishGridEffect({
        showReportPayment, myCaseResourceType, validatedReplenData, validProducts, 
        reportPaymentGridData, countryCode, filteredProduct, replenRPGridData, 
        replenGridData, usageDetails, setReplenRPGridData, setReplenGridData, 
        dispatch, setShippingDetails, patientDetails, patientIdMandatory, 
        getRPValidatedItemTableData, getValidatedItemTableData, getValidReplenishGridData, 
        checkIfValidProductsInRecordScreen,
    });

    useReplenDraftOrderEffect({
        replenGridData, usageDetails, patientDetails, filteredProduct, myCaseResourceType, reportUsageFormObj,
        reportUsagePatientDetails, countryCode, surgeryNumber, createRecordAndReplenDraftOrderObj, setReportUsageFormObj,
    });
    useUnidProductsValidationEffect({ validUnidProducts, reportPaymentGridData, showReportPayment, myCaseRefId, 
        countryCode, setFilteredProduct, setIsReplishBtnClicked, setShowUNiDPopUp, dispatch, 
        getRPValidatedItemTableData, getRPValidateItemsArr, validateProductDetails });
        
    useMazorCodeValidationEffect({ validateMazorCodeRes, screenSwitchOnReviewBtnClick, 
        screenSwitchOnUnidInfoBtnClick, setFooterButtonStatuses, footerButtonStatuses, cancel, saveAndExit });

    useOrderSubmissionEffect({ usageOrderSubmission, setCurrentActivity, REPORTPROGRESSTEPS, 
        currentActivity, unlockOrderFunc, myCaseResourceType, myCaseRefId, setShowSaveExitCompletionPopup });

    useBannerInfoEffect({ bannerInfo, checkProxyActive, checkImpersonationActive, saveExitBtnClickHandler, 
        dispatch, setDestructive, history, getRoutePathWithParams, setBannerDetails, setConfirmationBanner });

    useReplenRPGridEffect({ replenRPGridData, reportPaymentGridData, setReportPaymentGridData, setShippingDetailsRP });

    return (
        
        <ReportUsageContext.Provider
            value={{
                reportUsageFormObj,
                setReportUsageFormObj,
                usageDetails,
                footerButtonStatuses,
                setFooterButtonStatuses,
                replenRPGridData,
                setReplenRPGridData,
            }}
        >
            <Header
                usageDetails={usageDetails}
                footerButtonStatuses={footerButtonStatuses}
                isPriceOverride={isPriceOverride}
                backIconClickHandler={cancelBtnClickHandler}
                setshowReportPayment={setShowReportPayment}
                showReportPayment={showReportPayment}
                currentActivity={currentActivity}
                setCurrentActivity={setCurrentActivity}
                progressBarSteps={steps}
                progressBarIconClickHandler={progressBarIconClickHandler}
                shipAddress={shipAddress}
                isNavigatedToReportPayment={
                    myCaseResourceType === 'reportPayment'
                }
                selectedPhysicianData={selectedPhysicianData}
                setViewSurgeryNotes={setViewSurgeryNotes}
                viewSurgeryNotes={viewSurgeryNotes}
                noteCount={notesCount}
            />
            {showBackDrop() ? (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="reportUsage-index-backdrop-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    />
                </Backdrop>
            ) : (
                !viewSurgeryNotes && (
                    <UsageContainer
                        ref={usageContainerRef}
                        bannerMargin={bannerHeight}
                        usageOrderSubmission={
                            usageOrderSubmission &&
                            (usageOrderSubmission?.statusCode ||
                                usageOrderSubmission?.errorCode) &&
                            usageOrderSubmission?.clickedBtn === 'submit'
                        }
                        id="UsageContainer"
                        showReportPayment={showReportPayment}
                    >
                        <MultiViewComponent>
                            {showSubHeader() && (
                                <ReportUsageSubHeader
                                    usageDetails={usageDetails}
                                    selectedPhysicianData={
                                        selectedPhysicianData
                                    }
                                    noteCount={notesCount}
                                    openUNIDLinks={openUNIDLinks}
                                />
                            )}
                        </MultiViewComponent>
                        {showProgressBar() && (
                            <ProgressBar
                                margin={isCondensedView && '0px'}
                                padding={
                                    isCondensedView ? '0px 0px 24px 0px' : '0px'
                                }
                                isCondensedView={isCondensedView}
                                marginMb={isCondensedView && '5px -15px 2px -15px'}
                                backgroundColor={isCondensedView && 'white'}
                                backgroundMb={
                                    isCondensedView &&
                                    '#ffffff 0% 0% no-repeat padding-box'
                                }
                                boxShadowMb={
                                    isCondensedView && '0px 0px 6px #00000029'
                                }
                                steps={steps}
                                currentActivity={currentActivity}
                                setCurrentActivity={setCurrentActivity}
                                progressBarIconClickHandler={
                                    progressBarIconClickHandler
                                }
                                procedurePageVisibility={
                                    procedurePageVisibility
                                }
                                countryCode={countryCode}
                                replenishmentPageVisibilityUsage={
                                    replenishmentPageVisibilityUsage
                                }
                                isFromReportUsage={true}
                                height={isCondensedView ? '100%' : '72px'}
                            />
                        )}
                        {/* conditionally render the views */}
                        {showRecordScreen() && (
                            <RecordViewContainer
                                reportPaymentButtonVisibility={
                                    reportPaymentButtonVisibility
                                }
                                priceOverrideReportUsageVisibility={
                                    priceOverrideReportUsageVisibility
                                }
                                signatureVisibilityUsage={
                                    signatureVisibilityUsage
                                }
                                saveExitBtnClickHandler={
                                    saveExitBtnClickHandler
                                }
                                patientDetails={patientDetails}
                                setPatientDetails={setPatientDetail}
                                errForEmptyHrefIdField={errForEmptyHrefIdField}
                                setErrForEmptyHrefIdField={
                                    setErrForEmptyHrefIdField
                                }
                                errForEmptyPatientField={
                                    errForEmptyPatientField
                                }
                                setErrForEmptyPatientField={
                                    setErrForEmptyPatientField
                                }
                                isPriceOverride={isPriceOverride}
                                setPriceOverride={setPriceOverride}
                                usageDetails={usageDetails}
                                itemTableData={itemTableData}
                                filteredProduct={filteredProduct}
                                setFilteredProduct={setFilteredProduct}
                                priceOverrideTableData={priceOverrideTableData}
                                setPriceOverrideTableData={
                                    setPriceOverrideTableData
                                }
                                priceOverrideResetAllClickHandler={
                                    priceOverrideResetAllClickHandler
                                }
                                priceOverrideReason={priceOverrideReason}
                                pricingNotes={pricingNotes}
                                setPricingNotes={setPricingNotes}
                                setPriceOverrideReason={setPriceOverrideReason}
                                showHidePricesBtn={showHidePricesBtn}
                                setShowHidePricesBtn={setShowHidePricesBtn}
                                toggleHidePricesBtn={toggleHidePricesBtn}
                                setToggleHidePricesBtn={setToggleHidePricesBtn}
                                vendorCaseErrorRedirection={
                                    showCancelPopupOnVendorCaseIdHandler
                                }
                                isAccountCardExpanded={isAccountCardExpanded}
                                setIsAccountCardExpanded={
                                    setIsAccountCardExpanded
                                }
                                handleInputChange={handleInputChange}
                                accounts={accounts}
                                accountId={
                                    usageDetails?.accountId
                                        ? {
                                              accountId:
                                                  usageDetails?.accountId,
                                              accountFormattedName:
                                                  usageDetails?.accountFormattedName,
                                          }
                                        : ''
                                }
                                AccountTemplate={AccountTemplate}
                                accountValue={accountValue}
                                isAccountsOptionLoading={
                                    isAccountsOptionLoading
                                }
                                handleSearch={handleSearch}
                                handleClosePopUp={handleClosePopUp}
                                blockedAccountMessage={blockedAccountMessage}
                                setBlockedAccountMessage={
                                    setBlockedAccountMessage
                                }
                                handleOnfocus={handleOnfocus}
                                onBlur={onBlur}
                                showReportPayment={showReportPayment}
                                showUnidInfoScreen={showUnidInfoScreen}
                                isReportPaymentBtnDisabled={
                                    isReportPaymentBtnDisabled
                                }
                                currentActivity={currentActivity}
                                showORreportScreen={showORreportScreen}
                                reportPaymentBtnClickHandler={
                                    reportPaymentBtnClickHandler
                                }
                                setreportBtnClicked={setreportBtnClicked}
                                setShowReportPayment={setShowReportPayment}
                                countryCode={countryCode}
                            />
                        )}
                        {showReplenScreen() && (
                            <ReplenViewContainer
                                onClose={() => {
                                    try {
                                    setShipAddress(false);
                                    dispatch(clearValidateReplenData());
                                     } catch (error) {
                                           logErrorToConsole(error);
                                   }
                                }}
                                shipAddress={shipAddress}
                                setShipAddress={setShipAddress}
                                replenGridData={replenGridData}
                                setReplenGridData={setReplenGridData}
                                disableApplyShipToButton={replenGridData.some(
                                    (item) => item.isInvalidReplenQty
                                )}
                                showReportPayment={showReportPayment}
                                showCancelPopUp={showCancelPopUp}
                            />
                        )}
                        {showProcedureScreen() && (
                            <ProcedureViewContainer
                                procedurePageVisibility={
                                    procedurePageVisibility
                                }
                                procedureInfoData={procedureInfoData}
                                setProcedureInfoData={setProcedureInfoData}
                                setshowReportPayment={setShowReportPayment}
                                showReportPayment={showReportPayment}
                                proceduresList={proceduresList}
                                shipAddress={shipAddress}
                                setShipAddress={setShipAddress}
                                reportPaymentGridData={reportPaymentGridData}
                                setReportPaymentGridData={
                                    setReportPaymentGridData
                                }
                                selectedPhysicianData={selectedPhysicianData}
                                setSelectedPhysicianData={setPhysicianDropdown}
                                downArrow={downArrow}
                                dropDownValue={
                                    downArrow
                                        ? temporaryProcedureDropdownValue
                                        : procedureDropdownValue
                                }
                                setDropDownValue={setProcedureDropdown}
                                myCaseResourceType={myCaseResourceType}
                                rpInitialLoad={rpInitialLoad}
                                setRpInitialLoad={setRpInitialLoad}
                                onFlagChange={onFlagChange}
                                vendorCaseErrorRedirection={
                                    showCancelPopupOnVendorCaseIdHandler
                                }
                                setPriceOverride={setPriceOverride}
                                setRPPriceOverride={setRPPriceOverride}
                                isRPPriceOverride={isRPPriceOverride}
                                isPriceOverride={isPriceOverride}
                                setRPPriceOverrideData={setRPPriceOverrideData}
                                priceOverrideReason={priceOverrideReason}
                                setPriceOverrideReason={setPriceOverrideReason}
                                pricingNotes={pricingNotes}
                                setPricingNotes={setPricingNotes}
                                navigateToSpecifiedRPScreen={
                                    navigateToSpecifiedRPScreen
                                }
                                reportBtnClicked={reportBtnClicked}
                                currentActivity={currentActivity}
                                countryCode={countryCode}
                                progressBarClicked={progressBarClicked}
                                setIsReportPaymentScreen={
                                    setIsReportPaymentScreen
                                }
                                setMazorCaseCoverageInputValue={
                                    setMazorCaseCoverageInputValue
                                }
                                mazorCaseCoverageInputValue={
                                    mazorCaseCoverageInputValue
                                }
                                setSelectedMazorCaseCoverage={
                                    setSelectedMazorCaseCoverage
                                }
                                selectedMazorCaseCoverage={
                                    selectedMazorCaseCoverage
                                }
                                setViewSurgeryNotes={setViewSurgeryNotes}
                                setAdvancedEnergyCheck={setAdvancedEnergyCheck}
                                advancedEnergyCheck={advancedEnergyCheck}
                                setshowBiologisDetails={setshowBiologisDetails}
                                showBiologisDetails={showBiologisDetails}
                                isDraft={isDraft}
                                setDraft={setDraft}
                                pediatricDraftValue={pediatricDraftValue}
                                setPediatricDraftValue={setPediatricDraftValue}
                                setStealthAxisCaseCoverageInputValue={
                                    setStealthAxisCaseCoverageInputValue
                                }
                                stealthAxisCaseCoverageInputValue={
                                    stealthAxisCaseCoverageInputValue
                                }
                                setSelectedStealthAxisCaseCoverage={
                                    setSelectedStealthAxisCaseCoverage
                                }
                                selectedStealthAxisCaseCoverage={
                                    selectedStealthAxisCaseCoverage
                                }
                                physicianFieldText={physicianFieldText}
                                setPhysicianFieldText={setPhysicianFieldText}
                                physicianTextBoxType={physicianTextBoxType}
                                setPhysicianTextBoxType={setPhysicianTextBoxType}
                            />
                        )}
                        {showUnidSurgeryInfoScreen() && (
                            <UnidSurgeryInfo
                                unidSurgeryInfo={unidSurgeryInfo}
                                setUnidSurgeryInfo={setUnidSurgeryInfo}
                                storedUnidSurgeryData={storedUnidSurgeryData}
                                itemTableData={filteredProduct}
                                navigateToSpecifiedScreen={
                                    navigateToSpecifiedScreen
                                }
                                alertPopup={unidInfoAlertPopup}
                                setAlertPopup={setUnidInfoAlertPopup}
                                myCaseResourceType={myCaseResourceType}
                            />
                        )}
                        {showSurgeryORReport() && <SurgeryOrReport />}
                        {showReportPaymentButton() && (
                            <div>
                                <Button
                                    id={'reportUsage-procedure-reportPayment'}
                                    show={
                                        usageDetails?.unidId &&
                                        usageDetails?.unidSurgeryInfoPage
                                            ?.deliveredRodItems?.length > 0
                                            ? showUnidInfoScreen ||
                                              showORreportScreen
                                            : currentActivity === 'Procedure'
                                    }
                                    variant={
                                        isReportPaymentBtnDisabled
                                            ? ButtonStyles?.reportPaymentDisabled
                                            : ButtonStyles?.secondaryWhiteBorder
                                    }
                                    width={'160px'}
                                    mobileWidth={'155px'}
                                    mobileMargin={'30px 0 15px 0'}
                                    height={'38px'}
                                    // borderRadius={'19px'}
                                    margin={'5px 10px 0px 0px'}
                                    fontSize={'13px'}
                                    // fontFamily={'AvenirNextWorld Demi'}
                                    clicked={reportPaymentBtnClickHandler}
                                    disabled={isReportPaymentBtnDisabled}
                                    padding={'0'}
                                    // backgroundColor={
                                    //     isReportPaymentBtnDisabled &&
                                    //     '#EEEEEE'
                                    // }
                                    // border={
                                    //     isReportPaymentBtnDisabled &&
                                    //     '0.6000000238418579px solid #A5A5A5'
                                    // }
                                    // color={
                                    //     isReportPaymentBtnDisabled &&
                                    //     '#848484'
                                    // }
                                >
                                    <img
                                        src={
                                            isReportPaymentBtnDisabled
                                                ? ReportPaymentDisabledIcon
                                                : ReportPaymentIcon
                                        }
                                        style={{
                                            paddingRight: '7px',
                                        }}
                                    />
                                    {t('procedure.reportPaymentTitle')}
                                </Button>
                            </div>
                        )}

                        {showSubmitScreen() && (
                            <SubmitViewContainer
                                isFromOrderDetailsModal={
                                    isFromOrderDetailsModal
                                }
                                usageOrderSubmission={usageOrderSubmission}
                                reportUsageFormObj={reportUsageFormObj}
                                fromOrdersList={fromOrdersList}
                                resetReportUsageData={resetReportUsageData}
                                resetReportUsageStates={resetReportUsageStates}
                                myCaseResourceType={myCaseResourceType}
                                emails={emails}
                                vendorCaseErrorRedirection={
                                    showCancelPopupOnVendorCaseIdHandler
                                }
                                isSubmitClicked={isSubmitClicked}
                                setCurrentActivity={setCurrentActivity}
                            />
                        )}
                        {showReviewScreen() && (
                            <ReviewContainer
                                navigateToSpecifiedScreen={
                                    navigateToSpecifiedScreen
                                }
                                replenGridData={replenGridData.filter(
                                    (item) =>
                                        !item.accountOwned &&
                                        item.shippingDetails &&
                                        Object.keys(item.shippingDetails)
                                            .length > 0
                                )}
                                priceOverrideReason={priceOverrideReason}
                                emailInputBoxes={emailInputBoxes}
                                setEmailInputBoxes={setEmailInputBoxes}
                                setViewSurgeryNotes={setViewSurgeryNotes}
                                isSubmitClicked={isSubmitClicked}
                            />
                        )}
                        <ReportUsagePopupContainer
                            showUNiDPopUp={showUNiDPopUp}
                            isReplishBtnClicked={isReplishBtnClicked}
                            discardUNiDChangesBtnClickHandler={
                                discardUNiDChangesBtnClickHandler
                            }
                            closeCancelAlertPopup={closeCancelAlertPopup}
                            isPriceOverride={isPriceOverride}
                            showCancelPopUp={showCancelPopUp}
                            showUnsavedChangesPopup={showUnsavedChangesPopup}
                            isProcedureBtnClicked={isProcedureBtnClicked}
                            discardChangesBtnClickHandler={
                                discardChangesBtnClickHandler
                            }
                            showSurgeryNonUsePopup={showSurgeryNonUsePopup}
                            setShowSurgeryNonUsePopup={
                                setShowSurgeryNonUsePopup
                            }
                            submitUsageOrder={submitUsageOrder}
                            pdfNotAvailable={pdfNotAvailable}
                            setPdfNotAvailable={setPdfNotAvailable}
                        />
                        <CommonEmptyBox mobilePadding={'0 0 180px 0'} />
                    </UsageContainer>
                )
            )}
            {showSpinner() && (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="reportUsage-index-backdrop-pricingLoadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    />
                </Backdrop>
            )}
            {showFooter() && (
                <Footer
                    isPriceOverride={isPriceOverride}
                    footerButtonStatuses={footerButtonStatuses}
                    saveAndExitClickFlag={saveAndExitClick}
                    cancelBtnClickHandler={cancelBtnClickHandler}
                    saveExitBtnClickHandler={saveExitBtnClickHandler}
                    replenishBtnClickHandler={replenishBtnClickHandler}
                    procedureBtnClickHandler={procedureBtnClickHandler}
                    unidInfoBtnClickHandler={unidInfoBtnClickHandler}
                    ORreportBtnClickHandler={ORreportBtnClickHandler}
                    reviewBtnClickHandler={reviewBtnClickHandler}
                    submitBtnClickHandler={submitBtnClickHandler}
                    defaultBtnClickHandler={defaultBtnClickHandler}
                    shipAddress={shipAddress}
                    applyBtnClickHandler={applyBtnClickHandler}
                    nextBtnClickHandler={nextBtnClickHandler}
                    showReportPayment={showReportPayment}
                    poFlag={poFlag}
                    reportPaymentScreenName={reportPaymentScreenName}
                    myCaseResourceType={myCaseResourceType}
                    setProgressBarClicked={setProgressBarClicked}
                    reportUsage={true}
                    isLanguageChanged={isLanguageChanged}
                />
            )}
            <PopupContainer
                showWarningModel={showWarningModel}
                usageDetailsFailureAlert={usageDetailsFailureAlert}
                warningModalCloseHandler={warningModalCloseHandler}
                showCancelPopupOnVendorCaseIdHandler={
                    showCancelPopupOnVendorCaseIdHandler
                }
                showOrderLockedPopup={showOrderLockedPopup}
                handleCloseOrderLockPopup={handleCloseOrderLockPopup}
                closeOrderLockedPopup={closeOrderLockedPopup}
                viewSurgeryNotes={viewSurgeryNotes}
            />
            {showFindMaterialPopup && (
                <Popup
                    id="reportUsage-findMaterial-popup"
                    hideIcon={true}
                    zIndex={200001}
                >
                    <FindMaterialPopupContent>
                        <FindMaterialPopupMessage>
                            {t('reportUsage.findMaterial.popupMessage')}
                        </FindMaterialPopupMessage>
                        <FindMaterialPopupButtonContainer>
                            <Button
                                id="reportUsage-findMaterial-ok-button"
                                variant={ButtonStyles.primary}
                                width={'80px'}
                                height={'38px'}
                                clicked={() => {
                                    setShowFindMaterialPopup(false);
                                    handleCloseOrderLockPopup();
                                }}
                            >
                                {t('reportUsage.findMaterial.okButton')}
                            </Button>
                        </FindMaterialPopupButtonContainer>
                    </FindMaterialPopupContent>
                </Popup>
            )}
            {viewSurgeryNotes && (
                <SurgeryContainer
                    paddingBottom={'7vh'}
                    mobileViewHeight={'calc(100vh - 100px)'}
                >
                    {getViewBasedOnTemplate(viewSurgeryNotes)}
                </SurgeryContainer>
            )}
        </ReportUsageContext.Provider>
        
    );
};

export default ReportUsageContainer;
